import React, { useRef } from "react"

import { Container, Pages, ArrowButton, ScrollContainer } from "./styles"

import { FiChevronLeft, FiChevronRight } from "react-icons/fi"

interface PaginationProps {
  totalPages: number
  currentPage: number
  onPageClick: (page: number) => void
}

const Pagination: React.FC<PaginationProps> = ({
  totalPages,
  currentPage,
  onPageClick,
}) => {
  const scrollRef = useRef<HTMLDivElement>(null)
  const pages = Array.from({ length: totalPages }, (_, i) => i + 1)

  const scrollLeft = () => {
    scrollRef.current?.scrollBy({ left: -120, behavior: "smooth" })
  }

  const scrollRight = () => {
    scrollRef.current?.scrollBy({ left: 120, behavior: "smooth" })
  }

  return (
    <Container>
      <ArrowButton onClick={scrollLeft} type="button">
        <FiChevronLeft />
      </ArrowButton>

      <ScrollContainer ref={scrollRef}>
        {pages.map((page) => (
          <Pages
            key={page}
            onClick={() => onPageClick(page)}
            currentPage={page === currentPage}
          >
            {page}
          </Pages>
        ))}
      </ScrollContainer>

      <ArrowButton onClick={scrollRight} type="button">
        <FiChevronRight />
      </ArrowButton>
    </Container>
  )
}

export default Pagination
